import { render, staticRenderFns } from "./PropagandistTabs.vue?vue&type=template&id=cde3e0bc&"
import script from "./PropagandistTabs.vue?vue&type=script&lang=js&"
export * from "./PropagandistTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports